import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// GET shops
export const REQUEST_GET_SHOPS = 'REQUEST_GET_SHOPS';
export const REQUEST_GET_SHOPS_SUCCESS = 'REQUEST_GET_SHOPS_SUCCESS';
export const REQUEST_GET_SHOPS_FAILURE = 'REQUEST_GET_SHOPS_FAILURE';
export const ACTION_GET_SHOPS = 'ACTION_GET_SHOPS';

// GET products
export const REQUEST_GET_PRODUCTS = 'REQUEST_GET_PRODUCTS';
export const REQUEST_GET_PRODUCTS_SUCCESS = 'REQUEST_GET_PRODUCTS_SUCCESS';
export const REQUEST_GET_PRODUCTS_FAILURE = 'REQUEST_GET_PRODUCTS_FAILURE';
export const ACTION_GET_PRODUCTS = 'ACTION_GET_PRODUCTS';

// GET product detail
export const REQUEST_GET_PRODUCT_DETAIL = 'REQUEST_GET_PRODUCT_DETAIL';
export const REQUEST_GET_PRODUCT_DETAIL_SUCCESS = 'REQUEST_GET_PRODUCT_DETAIL_SUCCESS';
export const REQUEST_GET_PRODUCT_DETAIL_FAILURE = 'REQUEST_GET_PRODUCT_DETAIL_FAILURE';
export const ACTION_GET_PRODUCT_DETAIL = 'ACTION_GET_PRODUCT_DETAIL';
export const RESET_PRODUCT_DETAIL = 'RESET_PRODUCT_DETAIL';

const defaultState = {
  shops: [],
  fetchingShops: false,
  failedFetchingShops: false,
  shopsError: null,

  products: [],
  totalProducts: 0,
  currentPage: 1,
  limit: 10,
  fetchingProducts: false,
  failedFetchingProducts: false,
  productsError: null,

  productDetail: null,
  fetchingProductDetail: false,
  failedFetchingProductDetail: false,
  productDetailError: null,
};

const reducer = createReducer(defaultState, {
  [REQUEST_GET_SHOPS]: (state) => ({
    ...state,
    fetchingShops: true,
    failedFetchingShops: false,
    shopsError: null,
  }),
  [REQUEST_GET_SHOPS_SUCCESS]: (state, action) => ({
    ...state,
    shops: action.payload?.data || [],
    fetchingShops: false,
    failedFetchingShops: false,
    shopsError: null,
  }),
  [REQUEST_GET_SHOPS_FAILURE]: (state, action) => ({
    ...state,
    fetchingShops: false,
    failedFetchingShops: true,
    shopsError: action.payload,
  }),

  [REQUEST_GET_PRODUCTS]: (state) => ({
    ...state,
    fetchingProducts: true,
    failedFetchingProducts: false,
    productsError: null,
  }),
  [REQUEST_GET_PRODUCTS_SUCCESS]: (state, action) => {
    const responseData = action.payload?.data || action.payload;
    const items = responseData?.items || [];
    const total = responseData?.total || 0;

    return {
      ...state,
      products: items,
      totalProducts: total,
      currentPage: action.meta?.variables?.page || 1,
      limit: action.meta?.variables?.limit || 12,
      fetchingProducts: false,
      failedFetchingProducts: false,
      productsError: null,
    };
  },
  [REQUEST_GET_PRODUCTS_FAILURE]: (state, action) => ({
    ...state,
    fetchingProducts: false,
    failedFetchingProducts: true,
    productsError: action.payload,
  }),

  [REQUEST_GET_PRODUCT_DETAIL]: (state) => ({
    ...state,
    fetchingProductDetail: true,
    failedFetchingProductDetail: false,
    productDetailError: null,
  }),
  [REQUEST_GET_PRODUCT_DETAIL_SUCCESS]: (state, action) => ({
    ...state,
    productDetail: action.payload?.data || action.payload,
    fetchingProductDetail: false,
    failedFetchingProductDetail: false,
    productDetailError: null,
  }),
  [REQUEST_GET_PRODUCT_DETAIL_FAILURE]: (state, action) => ({
    ...state,
    fetchingProductDetail: false,
    failedFetchingProductDetail: true,
    productDetailError: action.payload,
  }),

  [RESET_PRODUCT_DETAIL]: (state) => ({
    ...state,
    productDetail: null,
    productDetailError: null,
  }),
});

export default reducer;
export const namespace = 'merchandise';

// Action creators
export const getShopsAPI = () => (dispatch, getState) => {
  return callAPI({
    method: 'get',
    apiPath: '/merchandise/shops',
    actionTypes: [REQUEST_GET_SHOPS, REQUEST_GET_SHOPS_SUCCESS, REQUEST_GET_SHOPS_FAILURE],
    variables: {},
    dispatch,
    getState,
  });
};

export const getProductsAPI =
  (shopId, page = 1, limit = 10) =>
  async (dispatch, getState) => {
    return await callAPI({
      method: 'get',
      apiPath: `/merchandise/shops/${shopId}/products`,
      actionTypes: [
        REQUEST_GET_PRODUCTS,
        REQUEST_GET_PRODUCTS_SUCCESS,
        REQUEST_GET_PRODUCTS_FAILURE,
      ],
      variables: { page, limit },
      dispatch,
      getState,
    });
  };

export const getProductDetailAPI = (shopId, productId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/merchandise/shops/${shopId}/products/${productId}`,
    actionTypes: [
      REQUEST_GET_PRODUCT_DETAIL,
      REQUEST_GET_PRODUCT_DETAIL_SUCCESS,
      REQUEST_GET_PRODUCT_DETAIL_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const resetProductDetail = () => ({
  type: RESET_PRODUCT_DETAIL,
});
